import { render, staticRenderFns } from "./appFooter.vue?vue&type=template&id=365813be&scoped=true"
import script from "./appFooter.vue?vue&type=script&lang=js"
export * from "./appFooter.vue?vue&type=script&lang=js"
import style0 from "./appFooter.vue?vue&type=style&index=0&id=365813be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365813be",
  null
  
)

export default component.exports